<template>
  <div class="emergency-dashboard">
    <!-- 主内容区 -->
    <div class="container main-content">
      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-content">
            <div class="stat-title">合格外教</div>
            <div class="stat-value">{{ statistics.totalTeachers }}</div>
          </div>
          <div class="stat-icon blue">
            <i class="ivu-icon ivu-icon-ios-person"></i>
          </div>
        </div>

        <div class="stat-card is-clickable" @click="openSlotDetail('available')">
          <div class="stat-content">
            <div class="stat-title">可用时段</div>
            <div class="stat-value">{{ statistics.totalAvailableSlots }}</div>
            <div class="stat-sub">当前总计 · 点击查看明细</div>
          </div>
          <div class="stat-icon green">
            <i class="ivu-icon ivu-icon-ios-time"></i>
          </div>
        </div>

        <div class="stat-card is-clickable" @click="openSlotDetail('used')">
          <div class="stat-content">
            <div class="stat-title">已使用时段</div>
            <div class="stat-value">{{ statistics.usedSlots }}</div>
            <div class="stat-sub">当前周 · 点击查看明细</div>
          </div>
          <div class="stat-icon purple">
            <i class="ivu-icon ivu-icon-ios-checkmark-circle"></i>
          </div>
        </div>
      </div>

      <!-- 标签页切换 -->
      <Tabs :key="isTrialPool ? 'trial' : 'pool'" value="pool" class="main-tabs" @on-click="handleTabChange">
        <TabPane :label="isTrialPool ? '试听外教池' : '应急外教池'" name="pool">
          <Alert v-if="isTrialPool" show-icon class="trial-rule-alert">
            入池规则（三条同时满足）
            <div slot="desc">
              <p>① 所有老师（包括应急外教非应急时间）</p>
              <p>② 当前外教分数 ≥ 70 分（同本月排行榜总分 / 批量查分接口）</p>
              <p>③ 单周买断 ≥ 20 节（统计周随搜索日期所在周一至周日）</p>
            </div>
          </Alert>
          <!-- 筛选面板 -->
          <div class="filter-panel">
            <Row :gutter="16">
              <i-col :span="5">
                <Input
                  v-model="filters.searchText"
                  placeholder="搜索老师姓名或ID"
                  @on-enter="applyFilters"
                >
                  <Icon type="ios-search" slot="prefix" />
                </Input>
              </i-col>
              <i-col :span="3">
                <admin-user-select
                  :status="1"
                  adminGroupCode="tchStudyAdviser"
                  v-model="filters.tchStudyAdviserId"
                  placeholder="外管"
                  @on-change="applyFilters"
                  @on-clear="applyFilters"
                  clearable>
                </admin-user-select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.tchChannel" placeholder="老师来源" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="1">外教</Option>
                </Select>
              </i-col>
              <i-col v-if="!isTrialPool" :span="3">
                <Select v-model="filters.emergency" placeholder="是否应急外教" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="1">是</Option>
                  <Option value="0">否</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.isAudition" placeholder="试听权限" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="y">是</Option>
                  <Option value="n">否</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.canBound" placeholder="绑定权限" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="1">是</Option>
                  <Option value="0">否</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.chinese" placeholder="会中文" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="1">是</Option>
                  <Option value="0">否</Option>
                </Select>
              </i-col>
            </Row>

            <Row :gutter="16" style="margin-top: 16px;">
              <i-col v-if="!isTrialPool" :span="3">
                <Select v-model="filters.bookMode" placeholder="约课方式" @on-change="applyFilters">
                  <Option value="bind">绑定老师</Option>
                  <Option value="temp">临时约课</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.accent" placeholder="口音" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="american">美音</Option>
                  <Option value="british">英音</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Select v-model="filters.gender" placeholder="性别" @on-change="applyFilters" @on-clear="applyFilters" clearable>
                  <Option value="male">男</Option>
                  <Option value="female">女</Option>
                </Select>
              </i-col>
              <i-col :span="3">
                <Date-picker
                  type="date"
                  format="yyyy-MM-dd"
                  placeholder="搜索日期"
                  :clearable="false"
                  :value="filters.occupyDate"
                  @on-change="onOccupyDateChange"
                  style="width: 100%;"
                ></Date-picker>
              </i-col>
              <i-col :span="4">
                <Select v-model="filters.levelGroups" placeholder="级别" multiple @on-change="applyFilters" clearable>
                  <Option v-for="item in levelOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
              </i-col>
              <i-col :span="8">
                <Select v-model="filters.materialCodes" placeholder="教材" multiple @on-change="applyFilters" clearable>
                  <Option v-for="item in materialOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
              </i-col>
            </Row>

            <div class="filter-actions">
              <Button type="primary" @click="applyFilters" size="large" icon="ios-search" class="filter-btn">
                筛选
              </Button>
              <Button @click="resetFilters" size="large" icon="ios-refresh" class="reset-btn">
                重置
              </Button>
              <Button
                v-if="canRunEmergencyPool && !isTrialPool"
                type="warning"
                @click="runEmergencyPoolCheck"
                size="large"
                :loading="runCheckLoading"
                class="run-check-btn"
              >
                手动执行
              </Button>
            </div>

            <div class="time-filter-grid">
              <div class="time-filter-card required">
                <div class="time-filter-title">必选时段（筛选项）</div>
                <div class="same-teacher-row">
                  <span class="same-teacher-label">是否需要同一个老师</span>
                  <Select v-model="filters.sameTeacher" class="same-teacher-select" @on-change="applyFilters">
                    <Option value="1">是</Option>
                    <Option value="0">否</Option>
                  </Select>
                </div>
                <div class="time-row header">
                  <span>周几</span>
                  <span>上课时段</span>
                  <span>操作</span>
                </div>
                <div class="time-row" v-for="(item, index) in filters.requiredSlots" :key="'required-' + index">
                  <Select v-model="item.day" placeholder="周几" transfer>
                    <Option v-for="day in daysOfWeek" :key="day.key" :value="day.key">{{ day.label }}</Option>
                  </Select>
                  <Select v-model="item.slotId" placeholder="上课时段" transfer>
                    <Option v-for="slot in timeSlots" :key="slot.id" :value="slot.id">{{ slot.label }}</Option>
                  </Select>
                  <Button size="small" icon="trash-a" @click="removeSlotFilter('required', index)"></Button>
                </div>
                <Button type="primary" icon="plus" @click="addSlotFilter('required')">+必选时段</Button>
              </div>
            </div>
          </div>

          <!-- 时段矩阵 -->
          <div class="matrix-container">
            <div class="matrix-header">
              <h3>时段矩阵</h3>
              <span class="hint">{{ weekRangeLabel }}　点击单元格可多选必选时段，再点一次取消</span>
            </div>

            <table class="matrix-table">
              <thead>
                <tr>
                  <th>时段</th>
                  <th v-for="day in daysOfWeek" :key="day.key">{{ day.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="slot in timeSlots" :key="slot.id">
                  <td class="slot-label">{{ slot.label }}</td>
                  <td
                    v-for="day in daysOfWeek"
                    :key="day.key"
                    :class="getCellClass(day.key, slot.id)"
                    @click="handleCellClick(day.key, slot.id)"
                  >
                    {{ getCellCount(day.key, slot.id) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- 老师列表 -->
          <div class="teacher-list">
            <div class="teacher-list-header">
              <div class="header-left">
                <h3>外教列表</h3>
                <span>共 {{ filteredTeachers.length }} 位符合条件的老师</span>
                <span class="slot-legend">
                  <i class="slot-tag buyout"></i>买断
                  <i class="slot-tag shortTerm"></i>短期固定
                  <i class="slot-tag temp"></i>临时
                  <i class="slot-tag schedule"></i>已排课
                  <i class="slot-tag bound"></i>已绑定
                  <i class="slot-tag leave"></i>请假
                  <i class="slot-emergency-badge legend"></i>应急
                </span>
              </div>
            </div>

            <div class="teacher-items">
              <div
                class="teacher-item"
                v-for="teacher in filteredTeachers"
                :key="teacher.id"
              >
                <div class="teacher-info">
                  <div class="teacher-main">
                    <div class="teacher-name-row">
                      <a class="teacher-name" @click="openTchInfoModal(teacher.id)">{{ teacher.name }}</a>
                      <span v-if="scoreText(teacher)" class="tch-score-badge">{{ scoreText(teacher) }}</span>
                      <span class="teacher-id">#{{ teacher.id }}</span>
                    </div>

                    <div class="teacher-meta">
                        <span :class="['priority-badge', `p${teacher.priority}`]">
                        P{{ teacher.priority }}
                      </span>
                      <span class="attr-tag gender">
                        <i class="ivu-icon ivu-icon-ios-man" v-if="teacher.gender === 'male'"></i>
                        <i class="ivu-icon ivu-icon-ios-woman" v-else></i>
                        {{ teacher.gender === 'male' ? '男' : '女' }}
                      </span>
                      <span class="attr-tag accent">
                        <i class="ivu-icon ivu-icon-ios-globe"></i>
                        {{ teacher.accent === 'american' ? '美音' : '英音' }}
                      </span>
                      <span>
                        <i class="ivu-icon ivu-icon-ios-people"></i>
                        {{ teacher.tchStudyAdviserName || '-' }}
                      </span>
                      <span>
                        <i class="ivu-icon ivu-icon-ios-calendar"></i>
                        {{ teacher.hireDate }}
                      </span>
                    </div>

                    <div class="teacher-qualification">
                      <span class="qual-item pass">
                        <i class="ivu-icon ivu-icon-ios-checkmark-circle"></i>
                        {{ teacher.emergency === 1 ? '应急外教' : '非应急外教' }}
                      </span>
                      <span class="qual-item match-info" v-if="(teacher.requiredMatchCount || 0) + (teacher.backupMatchCount || 0) > 0">
                        <i class="ivu-icon ivu-icon-ios-funnel"></i>
                        必选 {{ teacher.requiredMatchCount || 0 }} / 备选 {{ teacher.backupMatchCount || 0 }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="teacher-slots" v-if="getTeacherSlots(teacher.id).length > 0">
                  <div class="slots-grid">
                    <div
                      class="day-slots"
                      v-for="daySlot in getTeacherSlots(teacher.id)"
                      :key="daySlot.day"
                    >
                      <span class="day-label">{{ getDayLabel(daySlot.day) }}</span>
                      <div class="slot-tags">
                        <span
                          v-for="slot in daySlot.slots"
                          :key="slot.slotId"
                          :class="['slot-tag', slotDisplayClass(slot)]"
                        >
                          <i v-if="isApprovedEmergencySlot(slot)" class="slot-emergency-badge" title="应急时段">应急</i>
                          {{ slot.label || getSlotLabel(slot.slotId) || slot.slotId }}
                          <template v-if="slot.status === 'schedule'">(已排课)</template>
                          <template v-if="slot.status === 'bound'">(已绑定)</template>
                          <template v-if="slot.status === 'leave'">(请假)</template>
                          <template v-if="slot.status === 'pending'">(待审)</template>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="empty-state" v-if="filteredTeachers.length === 0">
              <i class="ivu-icon ivu-icon-ios-person"></i>
              <p>暂无符合条件的老师</p>
            </div>
          </div>
        </TabPane>

        <TabPane v-if="!isTrialPool" label="待审核时段" name="pending">
          <div class="pending-review">
            <div class="card">
              <div class="pending-header">
                <div class="header-left">
                  <h3>待审核时段</h3>
                  <Tag size="small" color="#E6A23C">{{ pendingList.length }} 个待审核</Tag>
                </div>

                <div class="header-right" v-if="selectedIds.length > 0">
                  <span class="selected-count">已选 {{ selectedIds.length }} 项</span>
                  <Button type="primary" size="small" @click="batchApprove" class="btn-success">
                    <i class="ivu-icon ivu-icon-ios-checkmark"></i> 批量通过
                  </Button>
                  <Button type="primary" size="small" @click="batchReject" class="btn-danger" style="margin-left: 8px;">
                    <i class="ivu-icon ivu-icon-ios-close"></i> 批量拒绝
                  </Button>
                </div>
              </div>

              <div class="pending-info-bar">
                <i class="ivu-icon ivu-icon-ios-information-circle"></i>
                <span>
                  当学生结课或停课后，空出的外教时段如符合应急时段条件，将自动锁定为"待审核"状态。
                  请审核后决定是否加入应急池。
                </span>
              </div>

              <div class="pending-list" v-if="pendingList.length > 0">
                <Checkbox
                  v-model="selectAll"
                  @on-change="handleSelectAll"
                  class="select-all-checkbox"
                >
                  全选
                </Checkbox>

                <CheckboxGroup v-model="selectedIds">
                  <div class="pending-item" v-for="item in pendingList" :key="item.id">
                    <Checkbox :label="item.id" class="item-checkbox">
                      <span></span>
                    </Checkbox>

                  <div class="pending-info">
                    <div class="pending-teacher">
                      <span class="teacher-name">{{ item.teacher && item.teacher.name || '未知老师' }}</span>
                      <span class="teacher-id">#{{ item.teacherId }}</span>
                      <span v-if="item.teacher" :class="['qualification-badge', isQualified(item.teacher) ? 'qualified' : 'unqualified']">
                        {{ isQualified(item.teacher) ? '符合资格' : '不符合资格' }}
                      </span>
                    </div>

                    <div class="pending-slot">
                      <Tag size="small" color="#E6A23C">{{ getDayLabel(item.day) }}</Tag>
                      <Tag size="small" color="#909399">{{ getSlotLabel(item.slotId) }}</Tag>
                    </div>

                    <div class="pending-reason">
                      <Tag size="small" :color="item.reason === 'student_completed' ? '#67C23A' : '#409EFF'">
                        {{ item.reason === 'student_completed' ? '学生结课' : '学生停课' }}
                      </Tag>
                      <span v-if="item.studentInfo">{{ item.studentInfo }}</span>
                    </div>

                    <div class="pending-time">
                      <i class="ivu-icon ivu-icon-ios-time"></i> {{ item.createdAt }}
                    </div>
                  </div>

                  <div class="pending-actions">
                    <Button type="primary" size="small" @click="handleApprove(item.id)" class="btn-success">
                      <i class="ivu-icon ivu-icon-ios-checkmark"></i> 通过
                    </Button>
                    <Button type="primary" size="small" @click="handleReject(item.id)" class="btn-danger">
                      <i class="ivu-icon ivu-icon-ios-close"></i> 拒绝
                    </Button>
                  </div>
                </div>
              </CheckboxGroup>
              </div>

              <div class="empty-state" v-else>
                <i class="ivu-icon ivu-icon-ios-document"></i>
                <p>暂无待审核时段</p>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchInfoId"></tch-info-modal>
    <Modal
      v-if="!isTrialPool"
      v-model="runRangeVisible"
      title="手动执行"
      :mask-closable="false"
      width="420"
    >
      <Date-picker
        v-model="runDateRange"
        type="daterange"
        format="yyyy-MM-dd"
        placeholder="请选择时间范围"
        transfer
        style="width: 100%;"
      ></Date-picker>
      <div slot="footer">
        <Button @click="closeRunRange">取消</Button>
        <Button type="primary" :loading="runCheckLoading" @click="submitRunCheck">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="slotDetailVisible"
      :title="slotDetailTitle"
      :mask-closable="false"
      width="1200"
    >
      <Date-picker
        v-if="slotDetailKind === 'used'"
        v-model="slotDetailDateRange"
        type="daterange"
        format="yyyy-MM-dd"
        placeholder="请选择时间范围"
        transfer
        style="width: 100%; margin-bottom: 12px;"
        @on-change="onSlotDetailRangeChange"
      ></Date-picker>
      <div v-if="slotDetailKind === 'used'" class="slot-detail-week">统计范围 {{ slotDetail.weekStart }} ~ {{ slotDetail.weekEnd }}，共 {{ slotDetail.total }} 条</div>
      <div v-else class="slot-detail-week">统计周 {{ slotDetail.weekStart }} ~ {{ slotDetail.weekEnd }}，共 {{ slotDetail.total }} 条</div>
      <Table
        :columns="slotDetailColumns"
        :data="slotDetail.list"
        :loading="slotDetailLoading"
        height="480"
      ></Table>
      <div slot="footer">
        <Button @click="slotDetailVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  DAYS_OF_WEEK,
  TIME_SLOTS,
  getHeatLevel,
  getDayLabel,
  getSlotLabel
} from '@/utils/constants'
import AdminUserSelect from '../common/AdminUserSelect.vue'
import TchInfoModal from '../teacher/modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows } from '@/utils/tchScore'

export default {
  name: 'TeacherPoolOriginal',
  components: {
    AdminUserSelect,
    TchInfoModal
  },

  data () {
    return {
      showTchInfoModal: false,
      rankScoreSeq: 0,
      tchInfoId: null,
      activeTab: 'pool',
      daysOfWeek: DAYS_OF_WEEK,
      timeSlots: TIME_SLOTS,
      levelOptions: [
        { value: '1', label: 'Level1' },
        { value: '5', label: 'Level2' },
        { value: '2', label: 'Level3-Level5' },
        { value: '3', label: 'Level6-Level9' },
        { value: '4', label: 'Wonders及其他' },
        { value: '6', label: 'PU' }
      ],
      materialOptions: [
        { value: '4', label: 'Wonders' },
        { value: '6', label: 'Power up' }
      ],
      filters: {
        searchText: '',
        tchStudyAdviserId: '',
        tchChannel: '',
        emergency: '0',
        isAudition: '',
        canBound: '',
        chinese: '',
        levelGroups: [],
        materialCodes: [],
        sameTeacher: '1',
        requiredSlots: [{ day: '', slotId: '' }],
        backupSlots: [{ day: '', slotId: '' }],
        tempSchedule: '',
        gender: '',
        accent: '',
        days: [],
        slotIds: [],
        minSlots: '',
        occupyDate: this.$moment().format('YYYY-MM-DD'),
        bookMode: 'bind'
      },
      currentMonth: this.$moment().format('YYYY-MM'),
      statistics: {
        totalTeachers: 0,
        qualifiedTeachers: 0,
        totalAvailableSlots: 0,
        usedSlots: 0,
        pendingSlots: 0
      },
      teachers: [],
      matrixData: {},
      pendingSlots: [],
      selectedIds: [],
      selectAll: false,
      loading: false,
      loadSeq: 0,
      runCheckLoading: false,
      runRangeVisible: false,
      runDateRange: [],
      backupFilterEnabled: false,
      slotDetailVisible: false,
      slotDetailLoading: false,
      slotDetailKind: 'available',
      slotDetail: {
        weekStart: '',
        weekEnd: '',
        total: 0,
        list: []
      },
      slotDetailDateRange: [],
      slotDetailQueryKey: '',
      slotDetailRangeSilent: false
    }
  },

  computed: {
    isTrialPool () {
      const route = this.$route || {}
      return route.name === 'TrialTeacherPool' || route.path === '/emergency/trialTeacherPool'
    },

    canRunEmergencyPool () {
      return Number(this.$store.get('id')) === 318
    },

    filteredTeachers () {
      return this.teachers
    },

    pendingList () {
      return this.pendingSlots.filter(p => p.status === 'pending' || p.status === 1)
    },

    weekRangeLabel () {
      const day = this.$moment(this.filters.occupyDate || this.defaultOccupyDate())
      // 试听池默认按当前自然周展示；临时约课非试听仍按单日
      if (this.isTrialPool) {
        const start = day.clone().isoWeekday(1)
        const end = day.clone().isoWeekday(7)
        return `统计周 ${start.format('YYYY-MM-DD')} ~ ${end.format('YYYY-MM-DD')}`
      }
      if (this.filters.bookMode === 'temp') {
        return `统计日 ${day.format('YYYY-MM-DD')}`
      }
      const start = day.clone().isoWeekday(1)
      const end = day.clone().isoWeekday(7)
      return `统计周 ${start.format('YYYY-MM-DD')} ~ ${end.format('YYYY-MM-DD')}`
    },

    slotDetailTitle () {
      return this.slotDetailKind === 'used' ? '已使用时段明细' : '可用时段明细'
    },

    slotDetailColumns () {
      const dateTitle = this.slotDetailKind === 'used' ? '日期' : '本周日期'
      const columns = [
        { title: '老师ID', key: 'teacherId', width: 100 },
        { title: '老师姓名', key: 'teacherName', minWidth: 140 },
        { title: '星期', key: 'dayLabel', width: 90 },
        { title: '时段', key: 'slotLabel', width: 100 },
        { title: dateTitle, key: 'date', width: 130 },
        { title: '状态', key: 'statusLabel', width: 100 },
        { title: '绑定学生', key: 'boundStudent', width: 160 },
        { title: '空闲出来的时间', key: 'freedAt', width: 170 },
        { title: '使用时间', key: 'usedAt', width: 170 }
      ]
      if (this.slotDetailKind !== 'used') {
        return columns.filter(col => col.key !== 'boundStudent')
      }
      return columns
    }
  },

  watch: {
    '$route.name' () {
      if (this.isTrialPool) {
        this.activeTab = 'pool'
        this.runRangeVisible = false
        this.filters.bookMode = 'temp'
        this.$set(this.filters, 'occupyDate', this.defaultOccupyDate())
      }
      this.loadData()
    }
  },

  mounted () {
    if (this.isTrialPool) {
      this.filters.bookMode = 'temp'
      this.$set(this.filters, 'occupyDate', this.defaultOccupyDate())
    }
    this.loadData()
  },

  methods: {
    getDayLabel,
    getSlotLabel,

    buildQuery (pageSize = 1000) {
      const requiredSlotKeys = this.buildSlotKeys(this.filters.requiredSlots)
      const backupSlotKeys = this.buildSlotKeys(this.filters.backupSlots)
      const levelGroups = this.filters.levelGroups || []
      const materialCodes = this.filters.materialCodes || []
      const query = {
        month: this.currentMonth,
        startDate: this.filters.occupyDate || this.defaultOccupyDate(),
        bookMode: this.isTrialPool ? 'temp' : (this.filters.bookMode || 'bind'),
        searchText: this.filters.searchText || null,
        tchStudyAdviserId: this.toNumberOrNull(this.filters.tchStudyAdviserId),
        tchChannel: this.toNumberOrNull(this.filters.tchChannel),
        emergency: this.toNumberOrNull(this.filters.emergency),
        isAudition: this.filters.isAudition || null,
        canBound: this.toNumberOrNull(this.filters.canBound),
        chinese: this.toNumberOrNull(this.filters.chinese),
        levelGroups: levelGroups.length ? levelGroups : null,
        materialCodes: materialCodes.length ? materialCodes : null,
        requiredSlotKeys: requiredSlotKeys.length ? requiredSlotKeys : null,
        sameTeacher: this.toNumberOrNull(this.filters.sameTeacher),
        backupSlotKeys: this.backupFilterEnabled && backupSlotKeys.length ? backupSlotKeys : null,
        tempSchedule: this.toNumberOrNull(this.filters.tempSchedule),
        gender: this.filters.gender || null,
        accent: this.filters.accent || null,
        minSlots: this.filters.minSlots ? Number(this.filters.minSlots) : null,
        days: this.filters.days.length ? this.filters.days : null,
        slotIds: this.filters.slotIds.length ? this.filters.slotIds : null,
        qualifiedOnly: false,
        pageIndex: 1,
        pageSize
      }
      if (this.isTrialPool) {
        query.pool = 'trial'
        query.emergency = null
      }
      return query
    },

    defaultOccupyDate () {
      return this.$moment().format('YYYY-MM-DD')
    },

    onOccupyDateChange (val) {
      const occupyDate = val ? this.$moment(val).format('YYYY-MM-DD') : this.defaultOccupyDate()
      this.$set(this.filters, 'occupyDate', occupyDate)
      this.applyFilters()
    },

    toNumberOrNull (value) {
      return value === '' || value === null || value === undefined ? null : Number(value)
    },

    buildSlotKeys (list) {
      return (list || []).filter(item => item && item.day && item.slotId).map(item => `${item.day}:${item.slotId}`)
    },

    getSlotFilterList (type) {
      return type === 'required' ? this.filters.requiredSlots : this.filters.backupSlots
    },

    addSlotFilter (type) {
      this.getSlotFilterList(type).push({ day: '', slotId: '' })
    },

    removeSlotFilter (type, index) {
      const list = this.getSlotFilterList(type)
      list.splice(index, 1)
      if (!list.length) {
        list.push({ day: '', slotId: '' })
      }
      this.applyFilters()
    },

    async loadData () {
      const seq = ++this.loadSeq
      this.loading = true
      try {
        await Promise.all([
          this.loadStatistics(),
          this.loadTeachers(),
          this.loadMatrix()
        ])
      } finally {
        if (seq === this.loadSeq) {
          this.loading = false
        }
      }
    },

    async loadStatistics () {
      const seq = this.loadSeq
      const res = await this.$http.post('/emergency/teacherPool/statistics', this.buildQuery())
      if (seq !== this.loadSeq) {
        return
      }
      if (res && res.data) {
        this.statistics = res.data
      }
    },

    openSlotDetail (kind) {
      this.slotDetailKind = kind
      this.slotDetail = {
        weekStart: '',
        weekEnd: '',
        total: 0,
        list: []
      }
      this.slotDetailVisible = true
      if (kind === 'used') {
        this.applyUsedWeekRange(true)
        return
      }
      this.loadSlotDetails()
    },

    defaultUsedWeekRange () {
      const start = this.$moment().isoWeekday(1).startOf('day')
      const end = start.clone().isoWeekday(7).startOf('day')
      return [start.toDate(), end.toDate()]
    },

    usedRangeKey (range) {
      const list = Array.isArray(range) ? range : []
      const startDate = this.formatRunDate(list[0])
      const endDate = this.formatRunDate(list[1])
      if (!startDate || !endDate) {
        return ''
      }
      return startDate + '|' + endDate
    },

    applyUsedWeekRange (reload) {
      const range = this.defaultUsedWeekRange()
      this.slotDetailQueryKey = this.usedRangeKey(range)
      this.slotDetailRangeSilent = true
      this.slotDetailDateRange = range
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.slotDetailRangeSilent = false
        })
      })
      if (reload) {
        this.loadSlotDetails()
      }
    },

    onSlotDetailRangeChange (value) {
      if (this.slotDetailKind !== 'used' || this.slotDetailRangeSilent) {
        return
      }
      const key = this.usedRangeKey(value)
      if (!key) {
        this.applyUsedWeekRange(true)
        return
      }
      if (key === this.slotDetailQueryKey) {
        return
      }
      this.slotDetailQueryKey = key
      this.loadSlotDetails()
    },

    isCurrentSlotDetailQuery (kind, queryKey) {
      if (kind !== this.slotDetailKind) {
        return false
      }
      if (kind !== 'used') {
        return true
      }
      return queryKey === this.slotDetailQueryKey
    },

    async loadSlotDetails () {
      const kind = this.slotDetailKind
      let queryKey = 'available'
      const payload = this.buildQuery()
      payload.kind = kind
      if (kind === 'used') {
        if (!this.slotDetailQueryKey) {
          this.slotDetailQueryKey = this.usedRangeKey(this.defaultUsedWeekRange())
        }
        queryKey = this.slotDetailQueryKey
        const parts = queryKey.split('|')
        payload.startDate = parts[0]
        payload.endDate = parts[1]
      }
      this.slotDetailLoading = true
      try {
        const res = await this.$http.post('/emergency/teacherPool/slotDetails', payload)
        if (!this.isCurrentSlotDetailQuery(kind, queryKey)) {
          return
        }
        if (res && res.data) {
          this.slotDetail = {
            weekStart: res.data.weekStart || '',
            weekEnd: res.data.weekEnd || '',
            total: res.data.total || 0,
            list: res.data.list || []
          }
        }
      } finally {
        if (this.isCurrentSlotDetailQuery(kind, queryKey)) {
          this.slotDetailLoading = false
        }
      }
    },

    async loadTeachers () {
      const seq = this.loadSeq
      const res = await this.$http.post('/emergency/teacherPool/teachers', this.buildQuery())
      if (seq !== this.loadSeq) {
        return
      }
      this.teachers = res && res.data && res.data.data ? res.data.data : []
      this.loadMonthRankScores()
    },

    async loadMatrix () {
      const seq = this.loadSeq
      const res = await this.$http.post('/emergency/teacherPool/matrix', this.buildQuery())
      if (seq !== this.loadSeq) {
        return
      }
      this.matrixData = res && res.data && res.data.matrix ? res.data.matrix : {}
    },

    async loadPending () {
      const res = await this.$http.post('/emergency/teacherPool/pending', {
        month: this.currentMonth,
        status: 'pending',
        pageIndex: 1,
        pageSize: 1000
      })
      this.pendingSlots = res && res.data && res.data.data ? res.data.data : []
    },

    isQualified (teacher) {
      return teacher && teacher.qualified
    },

    handleSelectAll (checked) {
      if (checked) {
        // 确保 ID 类型一致，都转为 Number 类型
        this.selectedIds = this.pendingList.map(p => Number(p.id))
      } else {
        this.selectedIds = []
      }
      // 使用 nextTick 确保 DOM 更新
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },

    slotDisplayClass (slot) {
      if (!slot) {
        return 'buyout'
      }
      if (slot.status === 'schedule' || slot.status === 'bound' || slot.status === 'leave' || slot.status === 'pending') {
        return slot.status
      }
      return slot.type || 'buyout'
    },

    /** 已审核通过的应急格（后端 emergency=1） */
    isApprovedEmergencySlot (slot) {
      if (!slot) return false
      return slot.emergency === 1 || slot.emergency === '1'
    },

    getTeacherSlots (teacherId) {
      const teacher = this.teachers.find(item => item.id === teacherId)
      if (!teacher || !teacher.slots || !teacher.slots.length) {
        return []
      }
      const slotsByDay = {}
      teacher.slots.forEach(slot => {
        if (!slotsByDay[slot.day]) {
          slotsByDay[slot.day] = []
        }
        slotsByDay[slot.day].push(slot)
      })
      const dayOrder = this.daysOfWeek.map(item => item.key)
      return Object.keys(slotsByDay).sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)).map(day => ({
        day,
        slots: slotsByDay[day].slice().sort((a, b) => {
          const left = a.label || this.getSlotLabel(a.slotId) || a.slotId || ''
          const right = b.label || this.getSlotLabel(b.slotId) || b.slotId || ''
          return left.localeCompare(right)
        })
      }))
    },

    getCellCount (day, slotId) {
      if (this.matrixData[day] && this.matrixData[day][slotId] !== undefined) {
        return this.matrixData[day][slotId]
      }
      return 0
    },

    isCellSelected (day, slotId) {
      return (this.filters.requiredSlots || []).some(item => item && item.day === day && item.slotId === slotId)
    },

    getCellClass (day, slotId) {
      const count = this.getCellCount(day, slotId)
      const level = getHeatLevel(count)
      return {
        'matrix-cell': true,
        [`level-${level}`]: true,
        selected: this.isCellSelected(day, slotId)
      }
    },

    handleCellClick (day, slotId) {
      const list = (this.filters.requiredSlots || []).filter(item => item && item.day && item.slotId)
      const idx = list.findIndex(item => item.day === day && item.slotId === slotId)
      if (idx >= 0) {
        list.splice(idx, 1)
      } else {
        list.push({ day, slotId })
      }
      this.$set(this.filters, 'requiredSlots', list.length ? list : [{ day: '', slotId: '' }])
      this.applyFilters()
    },

    async handleTabChange (tabName) {
      this.activeTab = tabName
      if (tabName === 'pending') {
        await this.loadPending()
      }
    },

    defaultRunDateRange () {
      const start = this.$moment().isoWeekday(1).subtract(1, 'week').startOf('day')
      const end = start.clone().add(6, 'days')
      return [start.toDate(), end.toDate()]
    },

    formatRunDate (value) {
      if (!value) {
        return ''
      }
      const day = this.$moment(value)
      if (!day.isValid()) {
        return ''
      }
      return day.format('YYYY-MM-DD')
    },

    runEmergencyPoolCheck () {
      this.runDateRange = this.defaultRunDateRange()
      this.runRangeVisible = true
    },

    closeRunRange () {
      this.runRangeVisible = false
    },

    async submitRunCheck () {
      if (this.runCheckLoading) {
        return
      }
      const range = Array.isArray(this.runDateRange) ? this.runDateRange : []
      const startDate = this.formatRunDate(range[0])
      const endDate = this.formatRunDate(range[1])
      if (!startDate || !endDate) {
        this.$Message.warning('请选择时间范围')
        return
      }
      if (startDate > endDate) {
        this.$Message.warning('开始不能晚于结束')
        return
      }
      this.runCheckLoading = true
      try {
        const res = await this.$http.post('/emergency/teacherPool/runCheck', {
          startDate: startDate,
          endDate: endDate
        })
        if (res && res.status === 'ok') {
          this.runRangeVisible = false
          this.$Message.success((res.data && String(res.data)) || '已执行')
          await this.loadData()
        }
      } finally {
        this.runCheckLoading = false
      }
    },

    async applyFilters () {
      await this.loadData()
      this.$Message.success('筛选条件已应用')
    },

    async resetFilters () {
      this.filters = {
        searchText: '',
        tchStudyAdviserId: '',
        tchChannel: '',
        emergency: '0',
        isAudition: '',
        canBound: '',
        chinese: '',
        levelGroups: [],
        materialCodes: [],
        sameTeacher: '1',
        requiredSlots: [{ day: '', slotId: '' }],
        backupSlots: [{ day: '', slotId: '' }],
        tempSchedule: '',
        gender: '',
        accent: '',
        days: [],
        slotIds: [],
        minSlots: '',
        occupyDate: this.defaultOccupyDate(),
        bookMode: this.isTrialPool ? 'temp' : 'bind'
      }
      await this.loadData()
      this.$Message.success('筛选条件已重置')
    },

    handleApprove (pendingId) {
      this.approveSlot(pendingId)
    },

    handleReject (pendingId) {
      this.rejectSlot(pendingId)
    },

    approveSlot (pendingId) {
      this.$Modal.confirm({
        title: '确认审核',
        content: '确定通过此时段审核吗？通过后将加入应急池。',
        onOk: async () => {
          await this.$http.post(`/emergency/teacherPool/review/approve/${pendingId}`, {})
          this.$Message.success('审核通过')
          await this.loadData()
          await this.loadPending()
        }
      })
    },

    rejectSlot (pendingId) {
      this.$Modal.confirm({
        title: '确认拒绝',
        content: '确定拒绝此时段申请吗？拒绝后将从待审核列表移除。',
        onOk: async () => {
          await this.$http.post(`/emergency/teacherPool/review/reject/${pendingId}`, {})
          this.$Message.info('已拒绝')
          await this.loadData()
          await this.loadPending()
        }
      })
    },

    batchApprove () {
      if (!this.selectedIds.length) {
        this.$Message.warning('请先选择要审核的时段')
        return
      }
      this.$Modal.confirm({
        title: '批量审核通过',
        content: `确定通过选中的 ${this.selectedIds.length} 个时段吗？`,
        onOk: async () => {
          await this.$http.post('/emergency/teacherPool/review/batchApprove', {ids: this.selectedIds})
          this.selectedIds = []
          this.selectAll = false
          this.$Message.success('批量审核通过')
          await this.loadData()
          await this.loadPending()
        }
      })
    },

    batchReject () {
      if (!this.selectedIds.length) {
        this.$Message.warning('请先选择要拒绝的时段')
        return
      }
      this.$Modal.confirm({
        title: '批量拒绝',
        content: `确定拒绝选中的 ${this.selectedIds.length} 个时段吗？`,
        onOk: async () => {
          await this.$http.post('/emergency/teacherPool/review/batchReject', {ids: this.selectedIds})
          this.selectedIds = []
          this.selectAll = false
          this.$Message.info('批量拒绝成功')
          await this.loadData()
          await this.loadPending()
        }
      })
    },

    scoreText (teacher) {
      if (!teacher || teacher.monthRankScore == null || teacher.monthRankScore === '') {
        return ''
      }
      const num = Number(teacher.monthRankScore)
      if (isNaN(num)) {
        return ''
      }
      return num.toFixed(2)
    },
    loadMonthRankScores () {
      const rows = this.teachers || []
      if (!rows.length) {
        return
      }
      const ids = rows.map(function (row) { return row.id }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, rows, 'id', 'monthRankScore', map)
      })
    },
    openTchInfoModal (tchId) {
      this.tchInfoId = tchId
      this.showTchInfoModal = true
    }
  }
}
</script>

<style lang="less" scoped>
// 导入全局样式变量
@primary-color: #409EFF;
@success-color: #67C23A;
@warning-color: #E6A23C;
@danger-color: #F56C6C;
@info-color: #909399;

@text-primary: #303133;
@text-regular: #606266;
@text-secondary: #909399;
@text-placeholder: #C0C4CC;

@border-color: #DCDFE6;
@border-light: #E4E7ED;
@border-lighter: #EBEEF5;

@bg-color: #F5F7FA;
@bg-white: #FFFFFF;

// 全局样式 - 仪表盘风格
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.emergency-dashboard {
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background-color: @bg-color;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;

  // 容器
  .container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 24px;
  }

  // 页面标题 - 仪表盘风格
  .page-header {
    background: linear-gradient(135deg, #1E3A5F 0%, #2D5A87 50%, #3B7CB8 100%);
    color: white;
    padding: 24px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 4px 12px rgba(30, 58, 95, 0.3);

    .title {
      display: flex;
      align-items: center;
      gap: 16px;

      i {
        font-size: 32px;
        opacity: 0.9;
      }

      h1 {
        font-size: 24px;
        font-weight: 700;
        margin: 0;
        letter-spacing: 1px;
      }

      .subtitle {
        font-size: 13px;
        opacity: 0.75;
        font-weight: 400;
      }
    }
  }

  // 主内容区
  .main-content {
    padding: 0 24px;

    // 统计卡片 - 仪表盘风格
    .stat-cards {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-bottom: 14px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
      }
    }

    .stat-card {
      background: @bg-white;
      border-radius: 6px;
      padding: 10px 12px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: transform 0.15s, box-shadow 0.15s;
      border: 1px solid rgba(0, 0, 0, 0.04);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      &.is-clickable {
        cursor: pointer;
      }

      .stat-content {
        .stat-title {
          font-size: 12px;
          color: @text-secondary;
          margin-bottom: 2px;
          font-weight: 500;
        }

        .stat-value {
          font-size: 20px;
          font-weight: 700;
          color: @text-primary;
          line-height: 1.2;
        }

        .stat-sub {
          font-size: 11px;
          color: @text-secondary;
          margin-top: 2px;
        }
      }

      .stat-icon {
        width: 30px;
        height: 30px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        &.blue {
          background: linear-gradient(135deg, #E6F4FF 0%, #BAE0FF 100%);
          color: #1677FF;
        }

        &.green {
          background: linear-gradient(135deg, #F6FFED 0%, #B7EB8F 100%);
          color: #52C41A;
        }

        &.purple {
          background: linear-gradient(135deg, #F9F0FF 0%, #D3ADF7 100%);
          color: #722ED1;
        }
      }
    }

    // 标签页
    .main-tabs {
      margin-top: 24px;

      ::v-deep .ivu-tabs-tab {
        font-size: 15px;

        i {
          margin-right: 6px;
        }
      }
    }

    .trial-rule-alert {
      margin-bottom: 16px;

      p {
        line-height: 22px;
      }
    }

    // 筛选面板
    .filter-panel {
      background: @bg-white;
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      padding: 24px;
      margin-bottom: 24px;
      border: 1px solid rgba(0, 0, 0, 0.04);

      // 优化 Select 下拉框样式
      ::v-deep .ivu-select {
        .ivu-select-selection {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }

        .ivu-select-selected-value {
          font-size: 14px;
        }
      }

      // 优化下拉选项样式
      ::v-deep .ivu-select-dropdown {
        .ivu-select-item {
          padding: 10px 16px;
          font-size: 14px;
          line-height: 1.6;
        }
      }

      .filter-section {
        display: flex;
        align-items: center;

        .filter-label {
          width: 80px;
          font-weight: bold;
          color: @text-primary;
        }

        .ivu-checkbox-group {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }
      }

      // 按钮美化
      .filter-btn {
        background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
        border: none;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, #66B1FF 0%, #409EFF 100%);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .reset-btn {
        background: linear-gradient(135deg, #F5F7FA 0%, #E4E7ED 100%);
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, #FFFFFF 0%, #F5F7FA 100%);
          border-color: #409EFF;
          color: #409EFF;
          box-shadow: 0 4px 8px rgba(64, 158, 255, 0.2);
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .run-check-btn {
        background: linear-gradient(135deg, #E6A23C 0%, #CF9236 100%);
        border: none;
        box-shadow: 0 2px 8px rgba(230, 162, 60, 0.3);
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, #EBB563 0%, #E6A23C 100%);
          box-shadow: 0 4px 12px rgba(230, 162, 60, 0.4);
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }
      }

      .filter-actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 16px;
      }

      .time-filter-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
        margin-top: 16px;

        @media (max-width: 1100px) {
          grid-template-columns: 1fr;
        }
      }

      .time-filter-card {
        border: 1px solid @border-light;
        border-radius: 6px;
        padding: 14px;
        background: #FAFCFF;

        &.backup {
          background: #FFFCF7;

          &.disabled {
            opacity: 0.5;
          }
        }
      }

      .time-filter-title {
        font-size: 14px;
        font-weight: 600;
        color: @text-primary;
        margin-bottom: 10px;
      }

      .same-teacher-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
      }

      .same-teacher-label {
        flex: none;
        color: #606266;
      }

      .same-teacher-select {
        width: 88px;
      }

      .time-row {
        display: grid;
        grid-template-columns: minmax(120px, 1fr) minmax(140px, 1fr) 64px;
        gap: 8px;
        align-items: center;
        margin-bottom: 8px;

        &.header {
          font-size: 12px;
          color: @text-secondary;
          margin-bottom: 6px;
        }
      }
    }

    // 时段矩阵 - 仪表盘风格
    .matrix-container {
      background: @bg-white;
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      overflow: hidden;
      margin-bottom: 24px;
      border: 1px solid rgba(0, 0, 0, 0.04);
    }

    .matrix-header {
      padding: 20px 24px;
      border-bottom: 1px solid @border-lighter;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FAFAFA;

      h3 {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        color: @text-primary;
      }

      .hint {
        font-size: 13px;
        color: @text-secondary;
      }
    }

    .matrix-table {
      width: 100%;
      border-collapse: collapse;

      th, td {
        padding: 14px 16px;
        text-align: center;
        border: 1px solid @border-lighter;
      }

      th {
        background: #FAFAFA;
        font-weight: 600;
        color: @text-primary;
        font-size: 14px;
      }

      .slot-label {
        text-align: left;
        font-weight: 600;
        background: #FAFAFA;
        font-family: 'SF Mono', Monaco, monospace;
        font-size: 13px;
        color: #595959;
      }

      .matrix-cell {
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 70px;
        font-weight: 600;
        font-size: 16px;

        &:hover {
          transform: scale(1.08);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          position: relative;
        }

        &.level-0 { background: #F5F5F5; color: #BFBFBF; }
        &.level-1 { background: #D9F7BE; color: #389E0D; }
        &.level-2 { background: #B7EB8F; color: #237804; }
        &.level-3 { background: #95DE64; color: #135200; }
        &.level-4 { background: #73D13D; color: white; text-shadow: 0 1px 2px rgba(0,0,0,0.2); }
        &.level-5 { background: #52C41A; color: white; text-shadow: 0 1px 2px rgba(0,0,0,0.2); }

        &.selected {
          outline: 3px solid #1677FF;
          outline-offset: -3px;
        }
      }
    }

    // 老师列表 - 仪表盘风格
    .teacher-list {
      background: @bg-white;
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      overflow: hidden;
      border: 1px solid rgba(0, 0, 0, 0.04);
    }

    .teacher-list-header {
      padding: 20px 24px;
      border-bottom: 1px solid @border-lighter;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FAFAFA;

      .header-left {
        display: flex;
        align-items: center;
        gap: 12px;

        h3 {
          font-size: 18px;
          font-weight: 600;
          margin: 0;
          color: @text-primary;
        }

        span {
          font-size: 14px;
          color: @text-secondary;
        }

        .slot-legend {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-left: 8px;
          font-size: 12px;
          color: @text-secondary;

          .slot-tag {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 2px;

            &.buyout {
              background: #00DEFF;
            }

            &.shortTerm {
              background: #1B5E20;
            }

            &.temp {
              background: #66CC33;
            }

            &.schedule {
              background: #FF9900;
            }

            &.bound {
              background: #FFCCFF;
            }

            &.leave {
              background: #AEAEAE;
            }
          }
        }
      }
    }

    .teacher-items {
      max-height: 600px;
      overflow-y: auto;
    }

    .teacher-item {
      padding: 20px 24px;
      border-bottom: 1px solid @border-lighter;
      transition: background 0.2s;

      &:hover {
        background: #FAFAFA;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .teacher-info {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 12px;

      .teacher-main {
        flex: 1;

        
        .tch-score-badge {
          margin-left: 4px;
          padding: 0 4px;
          border-radius: 7px;
          background: #ff9900;
          color: #fff;
          font-size: 10px;
          line-height: 14px;
        }
.teacher-name-row {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 8px;

          .teacher-name {
            font-weight: 700;
            font-size: 16px;
            color: @primary-color;
            cursor: pointer;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
              opacity: 0.8;
            }
          }

          .teacher-id {
            font-size: 13px;
            color: @text-secondary;
            font-family: 'SF Mono', Monaco, monospace;
          }
        }

        .teacher-meta {
          display: flex;
          align-items: center;
          gap: 16px;
          font-size: 13px;
          color: #595959;
          flex-wrap: wrap;

          .attr-tag {
            display: inline-block;
            padding: 3px 10px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 500;

            &.gender {
              background: linear-gradient(135deg, #E6F4FF 0%, #BAE0FF 100%);
              color: #0958D9;
            }
            &.accent {
              background: linear-gradient(135deg, #F9F0FF 0%, #D3ADF7 100%);
              color: #531DAB;
            }

            i {
              margin-right: 4px;
            }
          }
        }

        .teacher-qualification {
          display: flex;
          align-items: center;
          gap: 20px;
          font-size: 13px;
          margin-top: 8px;
          color: #595959;

          .qual-item {
            display: flex;
            align-items: center;
            gap: 6px;

            i {
              color: #8C8C8C;
            }

            &.pass { color: #52C41A; }
            &.fail { color: #FF4D4F; }
          }
        }
      }
    }

    .teacher-slots {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px dashed #E8E8E8;

      .slots-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      .day-slots {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #F0FDF4;
        padding: 6px 10px;
        border-radius: 4px;

        .day-label {
          font-weight: 600;
          color: #15803D;
          min-width: 32px;
          font-size: 13px;
        }

        .slot-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;

          .slot-tag {
            position: relative;
            font-size: 11px;
            padding: 2px 6px;
            border-radius: 3px;
            font-family: monospace;

            &.buyout,
            &.idle,
            &.approved {
              background: #00DEFF;
              color: #003A44;
            }

            &.shortTerm {
              background: #1B5E20;
              color: #FFFFFF;
            }

            &.temp {
              background: #66CC33;
              color: #145214;
            }

            &.schedule {
              background: #FF9900;
              color: #7A3E00;
            }

            &.bound {
              background: #FFCCFF;
              color: #7A3A7A;
            }

            &.leave {
              background: #AEAEAE;
              color: #333333;
            }

            &.pending {
              background: #FEF3C7;
              color: #B45309;
              border: 1px solid #FCD34D;
            }
          }
        }
      }
    }


    .slot-emergency-badge {
      position: absolute;
      top: -5px;
      right: -4px;
      z-index: 1;
      font-size: 9px;
      font-style: normal;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      line-height: 1;
      padding: 1px 3px;
      border-radius: 2px;
      background: #ED4014;
      color: #fff;
      pointer-events: none;
      transform: scale(0.92);
      transform-origin: top right;

      &.legend {
        position: static;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
        transform: none;
      }
    }

    // 资格标签 - 复制原项目样式
    .qualification-badge {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 12px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;

      &.qualified {
        background: linear-gradient(135deg, #F6FFED 0%, #D9F7BE 100%);
        color: #389E0D;
        border: 1px solid #B7EB8F;
      }

      &.unqualified {
        background: linear-gradient(135deg, #FFF1F0 0%, #FFCCC7 100%);
        color: #CF1322;
        border: 1px solid #FFA39E;
      }
    }

    // 优先级标签
    .priority-badge {
      display: inline-block;
      padding: 3px 10px;
      border-radius: 6px;
      font-size: 11px;
      font-weight: 700;

      &.p1 {
        background: linear-gradient(135deg, #FFF1F0 0%, #FFCCC7 100%);
        color: #CF1322;
      }
      &.p2 {
        background: linear-gradient(135deg, #FFF7E6 0%, #FFD591 100%);
        color: #D46B08;
      }
      &.p3 {
        background: linear-gradient(135deg, #F5F5F5 0%, #D9D9D9 100%);
        color: #595959;
      }
    }

    // 待审核列表 - 完全复制原项目样式
    .pending-review {
      .card {
        background: @bg-white;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        padding: 24px;
        border: 1px solid rgba(0, 0, 0, 0.04);
      }

      .pending-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;

          h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
          }
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;

          .selected-count {
            font-size: 13px;
            color: #606266;
          }
        }
      }

      .pending-info-bar {
        background: #FDF6EC;
        border: 1px solid #FAECD8;
        border-radius: 4px;
        padding: 12px 16px;
        margin-bottom: 16px;
        font-size: 13px;
        color: #E6A23C;

        i {
          margin-right: 8px;
        }
      }

      .select-all-checkbox {
        margin-bottom: 12px;
        padding-left: 8px;
      }

      .pending-list {
        max-height: 600px;
        overflow-y: auto;
      }

      .pending-item {
        display: flex;
        align-items: flex-start;
        padding: 16px;
        border: 1px solid #EBEEF5;
        border-radius: 8px;
        margin-bottom: 12px;
        transition: all 0.2s;

        &:hover {
          border-color: #409EFF;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
        }

        .item-checkbox {
          margin-right: 12px;
          margin-top: 4px;
        }

        .pending-info {
          flex: 1;

          .pending-teacher {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;
            flex-wrap: wrap;

            .teacher-name {
              font-weight: 600;
              font-size: 15px;
            }

            .teacher-id {
              font-size: 12px;
              color: #909399;
              font-family: monospace;
            }
          }

          .pending-slot {
            display: flex;
            gap: 8px;
            margin-bottom: 8px;
            align-items: center;
          }

          .pending-reason {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: #606266;
            margin-bottom: 8px;
            flex-wrap: wrap;
          }

          .pending-time {
            font-size: 12px;
            color: #909399;

            i {
              margin-right: 4px;
            }
          }
        }

        .pending-actions {
          display: flex;
          gap: 8px;

          // 自定义按钮样式以匹配Element UI
          ::v-deep .ivu-btn {
            &.btn-success {
              background-color: #67C23A !important;
              border-color: #67C23A !important;
              color: white !important;

              &:hover {
                background-color: #85ce61 !important;
                border-color: #85ce61 !important;
              }
            }

            &.btn-danger {
              background-color: #F56C6C !important;
              border-color: #F56C6C !important;
              color: white !important;

              &:hover {
                background-color: #f78989 !important;
                border-color: #f78989 !important;
              }
            }
          }
        }
      }
    }

    // 空状态
    .empty-state {
      padding: 60px;
      text-align: center;
      color: @text-secondary;

      i {
        font-size: 64px;
        margin-bottom: 20px;
        opacity: 0.3;
      }

      p {
        font-size: 15px;
      }
    }
  }

  // 页脚
  .page-footer {
    background: @bg-white;
    border-top: 1px solid @border-lighter;
    padding: 16px 0;
    margin-top: auto;

    p {
      text-align: center;
      color: @text-secondary;
      font-size: 13px;
      margin: 0;
    }
  }
}

.slot-detail-week {
  margin-bottom: 12px;
  font-size: 13px;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// TeacherPoolOriginal.vue?e0443afc